import React from 'react';
import { motion } from 'framer-motion';
import { TrendingUp } from 'lucide-react';
export function Hero() {
  const scrollToContact = () => {
    const element = document.getElementById('contact');
    if (element) {
      element.scrollIntoView({
        behavior: 'smooth'
      });
    }
  };
  return <section className="relative felt-texture py-20 sm:py-32 overflow-hidden" data-id="element-77">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-78">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8
      }} className="text-center" data-id="element-79">
          <motion.div initial={{
          scale: 0.9
        }} animate={{
          scale: 1
        }} transition={{
          duration: 0.5
        }} className="inline-flex items-center space-x-2 bg-[#00ff88]/10 border border-[#00ff88]/30 rounded-full px-4 py-2 mb-6" data-id="element-80">
            <TrendingUp className="text-[#00ff88]" size={20} data-id="element-81" />
            <span className="text-[#00ff88] font-mono text-sm" data-id="element-82">
              Data-Driven iGaming Growth
            </span>
          </motion.div>

          <h1 className="text-4xl sm:text-5xl lg:text-6xl font-bold mb-6 leading-tight" data-id="element-83">
            Dominate Sports Betting
            <br data-id="element-84" />
            <span className="text-[#00ff88]" data-id="element-85">Affiliate Marketing</span>
          </h1>

          <p className="text-lg sm:text-xl text-gray-300 max-w-3xl mx-auto mb-10" data-id="element-86">
            We engineer high-converting affiliate funnels and SEO strategies
            that turn sports betting traffic into depositing players.
            Compliance-first, data-obsessed, results-guaranteed.
          </p>

          <motion.button whileHover={{
          scale: 1.05
        }} whileTap={{
          scale: 0.95
        }} onClick={scrollToContact} className="bg-[#00ff88] text-[#0a1a0f] px-8 py-4 rounded-lg font-bold text-lg hover:bg-[#22c55e] transition-colors glow-green" data-id="element-87">
            Get Your Free Audit
          </motion.button>

          <div className="mt-12 grid grid-cols-2 md:grid-cols-4 gap-6 max-w-4xl mx-auto" data-id="element-88">
            {[{
            value: '340%',
            label: 'Avg. Traffic Growth'
          }, {
            value: '€2.4M',
            label: 'Revenue Generated'
          }, {
            value: '89%',
            label: 'Conversion Boost'
          }, {
            value: '12.6x',
            label: 'Average ROI'
          }].map((stat, index) => <motion.div key={index} initial={{
            opacity: 0,
            y: 20
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            delay: 0.2 + index * 0.1
          }} className="bg-[#0d2818]/50 border border-[#00ff88]/20 rounded-lg p-4" data-id="element-89">
                <div className="text-2xl sm:text-3xl font-bold text-[#00ff88] font-mono" data-id="element-90">
                  {stat.value}
                </div>
                <div className="text-sm text-gray-400 mt-1" data-id="element-91">{stat.label}</div>
              </motion.div>)}
          </div>
        </motion.div>
      </div>
    </section>;
}